export default __webpack_public_path__ + "static/home-hero-5987ca93907922d980ac9ff958fc234f.mp4";